module.exports = __webpack_public_path__ + "img/home_img_font@2x.302179b7.png";